// import React from "react";
import React, { useState, useEffect } from 'react';

import TextField from '@mui/material/TextField';
import { Tooltip, Dropdown, OverlayTrigger, Button } from 'react-bootstrap';

import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import SelectBoxWithoutBoxComponent from '../../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import CommonModal from '../../../../../SharedModules/Dialog/CommonModal';
import SaveCancelPopup from '../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import CLTabs from './CLTabs';
import Preview from './Preview';
import Spinner from '../../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplaySuccessMessages from '../../../../../SharedModules/Errors/SuccessMessage';
import {
  closeTab,
  redirectURLLink,
  convertPDFURLFromAPI,
  emailValidation,
  convertHtmlToEmailPlainText,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { safeWindowOpen } from '../../../../../SharedModules/CommonUtilities/safeWindowOpen';
import SafeHtmlContent from '../../../../../SharedModules/CommonUtilities/SafeHtmlContent';
import {
  defaultSelectBy,
  InvNumSelectBy,
  printMedia,
  eitherMedia,
  printDraft,
  emailOptions,
} from '../ConstantData';
import {
  saveCreateTemplate,
  getPrintPreview,
  getPrintDraftPDFPreview,
  setCreateTemplateExtraState,
  dispatchErrorMsg,
  updateCreateLetterSaveApi,
  updateToMailIDCreateTemplate,
  updateFreeFromTextCreateTemplate,
  fetchCreateLetterDetail,
  dispatchGetInvDetailByInvBeforeRedirect,
  updateInvoiceDetailsByInvoiceNum,
  getFromMailIDCreateTemplate,
  dispatchGetToMailID,
  dispatchGetFromMailID,
  updateFromMailIDCreateTemplate,
  sendMailWithCreateTemplate,
  afterMailSendUpdateSendDate,
  dispatchSendMailForLetter,
} from '../../store/action';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../../../Maintain/Manufacturer/store/ManufacturerAction';
import {
  selectedType,
  dispatchCellClick,
} from '../../../../Maintain/Contract/store/actions';
import { getInvoiceDetailsByInvoiceNum as getInvoiceDetailsByInvNum } from '../../../../Display/invoice/store/actions';
import { getRebatePgmDetail } from '../../../../Maintain/RebateProgram/SearchRebate/store/actions';
import * as actiontype from '../../../../Maintain/RebateProgram/SearchRebate/store/actionTypes';
import {
  FAIL_PROCESSING_REQUEST,
  SAVE_NDC,
  EMAIL_INVALID,
  EMAIL_REQUIRED,
  ENTER_VALID_EMAIL_OR_CANCEL,
  EMAIL_ID_NOT_AVAILABLE,
} from '../../../../../SharedModules/Errors/constantMessageData';
import { checkActionAccessByRole } from '../../../../../SharedModules/utilities/utilities';
// import printerIcon from '../../../../../assets/images/Icon-printer.svg';

function CreateLetterDetail() {
  const dispatch = useDispatch();
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const RequestData = useSelector(
    (state) =>
      state?.sharedState?.CreateLetterReducer?.detailScrenData.searchData
  );
  const tabs = useSelector(
    (state) => state.sharedState.CreateLetterReducer.extraState.tabs
  );
  const extraState = useSelector(
    (state) => state?.sharedState?.CreateLetterReducer?.extraState
  );
  const errorMessages = useSelector(
    (state) => state?.sharedState?.CreateLetterReducer?.errorMessages
  );

  const detailScreenErrors = useSelector(
    (state) =>
      state.sharedState.CreateLetterReducer.errorMessages.detailScreenErrors
  );
  const getCreateLetterDetailData = useSelector(
    (state) =>
      state?.sharedState?.CreateLetterReducer?.detailScrenData.letterDetail
  );
  const getCreateLetterDetailHeader = useSelector(
    (state) =>
      state?.sharedState?.CreateLetterReducer?.detailScrenData.headerDetail
  );
  const saveCreateLetterData = useSelector(
    (state) => state?.sharedState?.CreateLetterReducer?.saveCreateLetterData
  );
  const fullScreenView = useSelector(
    (state) =>
      state.sharedState.CreateLetterReducer.extraState.fullScreenView
        .templateDetail
  );
  const customizeValue = useSelector(
    (state) => state.sharedState.CreateLetterReducer.extraState.customizeValue
  );
  const saveActionType = useSelector(
    (state) => state.sharedState.CreateLetterReducer.extraState.saveActionType
  );
  const sendMail = useSelector(
    (state) => state.sharedState.CreateLetterReducer.sendMail
  );
  const fromMailId = useSelector(
    (state) => state.sharedState.CreateLetterReducer.fromMailId
  );
  const toMailId = useSelector(
    (state) => state.sharedState.CreateLetterReducer.toMailId
  );
  const getInvDetail = useSelector(
    (state) => state.sharedState.CreateLetterReducer.getInvDetail
  );
  const invoiceDetail = useSelector(
    (state) => state.sharedState.CreateLetterReducer.invoiceDetail
  );
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const invoiceDetailsByInvoiceNum = useSelector(
    (state) =>
      state.sharedState.DisplayInvoiceReducer.invoiceDetailsByInvoiceNum
  );
  const pgmView = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.pgm_res
  );

  const pdfPreview = useSelector(
    (state) => state.sharedState.CreateLetterReducer.pdfPreview
  );
  const pdfDraftPreview = useSelector(
    (state) => state.sharedState.CreateLetterReducer.pdfDraftPreview
  );

  const tempLetterTableData = useSelector(
    (state) => state.sharedState.LetterReducer.tempLetterTableData
  );

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const history = useHistory();
  // const [fullScreenView, changeFullScreenView] = useState('');
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  const [manufactureType, setManufactureType] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [modalView, setModalView] = React.useState(false);
  const [isSaveOpen, setIsSaveOpen] = React.useState(false);
  // const [saveActionType, setSaveActionType] = useState('');
  const [modalMsg, setModalMsg] = React.useState(null);
  const [pdfUrl, setPdfURL] = React.useState(null);
  const [draftPdfUrl, setDraftPdfURL] = React.useState(null);
  const [viewEmail, setViewEmail] = React.useState(false);
  const [redirect, setRedirect] = React.useState(false);
  const [CustomizeLetter, setViewCustomizeLetter] = React.useState(false);
  const [freeFromTextValue, setFreeFromTextValue] = React.useState('');
  const [emailInputValue, setEmailInputValue] = React.useState({
    to: '',
    from: '',
  });
  const [viewEmailInput, setViewEmailInput] = React.useState({
    to: false,
    from: false,
  });
  const [toEmailIdValid, setToEmailValid] = React.useState(false);
  const [fromEmailIdValid, setFromEmailValid] = React.useState(false);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  // Find the object with the max 'letterId' from the 'letterHeaderVOs' array
  const maxLetter = tempLetterTableData?.letterHeaderVOs?.reduce((max, letter) => {
    return letter.letterId > max.letterId ? letter : max;
  }, tempLetterTableData?.letterHeaderVOs[0]);

  const letterIdToShow = maxLetter?.letterId || getCreateLetterDetailHeader?.letterId || '';
  const sentDtToShow = maxLetter?.sentDt || getCreateLetterDetailHeader?.sentDt || '';

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  // This run when state value changed and save in redux
  const setStateChange = (val) => {
    dispatch(
      setCreateTemplateExtraState({
        ...extraState,
        ...val,
      })
    );
  };

  // This run when error msg change and save in redux
  const setErrorStateChange = (val) => {
    dispatch(
      dispatchErrorMsg({
        ...errorMessages,
        ...val,
      })
    );
  };

  const callFewAPIWhenNotSameTemplate = React.useCallback(() => {
    const request = {};
    if (!_.isEmpty(RequestData) && !_.isEmpty(getCreateLetterDetailData)) {
      request.templateId =
        RequestData.selectedTemplate.templateId ||
        getCreateLetterDetailData?.templateId;
      request.templateVersion =
        RequestData.selectedTemplate.templateVersion ||
        getCreateLetterDetailData?.templateVersion;
      if (RequestData?.selectTypeCd === defaultSelectBy) {
        request.mfgId = !_.isEmpty(RequestData.mfgData)
          ? RequestData?.mfgData?.mfgId
          : getCreateLetterDetailData?.mfgId;
        request.quarter = RequestData?.quarterValue;
        request.rebateProgramCd =
          RequestData?.rebateProgramCd ||
          getCreateLetterDetailData?.rebateProgramCd;
      }
      if (RequestData?.selectTypeCd === InvNumSelectBy) {
        request.invoiceNumber = RequestData?.invoiceNum;
      }
    }
    if (!_.isEmpty(getCreateLetterDetailHeader)) {
      request.letterId = getCreateLetterDetailHeader?.letterId;
    }
    request.userId = logInUser;
    dispatch(dispatchGetInvDetailByInvBeforeRedirect([]));
    dispatch(
      dispatchGetToMailID({
        isUpdate: false,
        toMailId: getCreateLetterDetailData?.emailAddr,
      })
    );
    dispatch(getFromMailIDCreateTemplate({ userId: logInUser }));
    dispatch(getPrintPreview(request));
    dispatch(getPrintDraftPDFPreview(request));
    setLoading(false);
  }, [RequestData, getCreateLetterDetailData]);

  // Refresh Page---
  React.useEffect(() => {
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/createLetterDetail' && x.isRefresh;
      }).length > 0
    ) {
      dispatch(updateInvoiceDetailsByInvoiceNum(getInvDetail?.data));
      setErrorStateChange({
        detailPage: [],
        detailScreenErrors: [],
      });
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/createLetterDetail') {
          item.isRefresh = false;
        }
        return item;
      });
      if (!_.isEmpty(getCreateLetterDetailData)) {
        callFewAPIWhenNotSameTemplate();
        localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      }
    }
  }, [getCreateLetterDetailData, getInvDetail]);

  React.useEffect(() => {
    setLoading(false);
    if (pdfPreview && pdfPreview !== '') {
      const purl = convertPDFURLFromAPI(pdfPreview);
      setPdfURL(purl);
      if (extraState.printPdf) {
        if (getCreateLetterDetailData?.mediaCd === printMedia) {
          setStateChange({ printPdf: false });
          safeWindowOpen(purl);
        }
      }
    }
  }, [pdfPreview]);

  // draft pdf url
  React.useEffect(() => {
    setLoading(false);
    if (pdfDraftPreview && pdfDraftPreview !== '') {
      const purl = convertPDFURLFromAPI(pdfDraftPreview);
      setDraftPdfURL(purl);
    }
  }, [pdfDraftPreview]);

  // call again pdf api
  const callPDFAPIAfterSave = (data) => {
    setLoading(true);
    const request = {};
    if (!_.isEmpty(RequestData) && !_.isEmpty(data)) {
      request.templateId = data.templateId;
      request.templateVersion = data.templateVersion;
      request.letterId = data?.letterId;
      if (RequestData?.selectTypeCd === defaultSelectBy) {
        request.mfgId = !_.isEmpty(RequestData.mfgData)
          ? RequestData?.mfgData?.mfgId
          : getCreateLetterDetailData?.mfgId;
        request.quarter = RequestData?.quarterValue;
        request.rebateProgramCd = data.rebateProgramCd;
      }
      if (RequestData?.selectTypeCd === InvNumSelectBy) {
        request.invoiceNumber = data.invoiceNum;
      }
    }
    request.userId = logInUser;
    dispatch(getPrintPreview(request));
    dispatch(getPrintDraftPDFPreview(request));
  };
  // after Save letter
  React.useEffect(() => {
    if (extraState?.saveApiActive) {
      let msg = null;
      if (!_.isEmpty(saveCreateLetterData)) {
        if (
          saveCreateLetterData.message === 'SUCESS' &&
          saveCreateLetterData.status === '001'
        ) {
          setLoading(false);
          const data =
            saveCreateLetterData.createLetterSaveOrUpdateVO.letterHeaderVO;
          if (!_.isEmpty(data)) {
            if (extraState?.letterAction === 'FreeFromText') {
              const request = {
                letterId: data.letterId,
                freeFormText: customizeValue,
                userId: logInUser,
              };
              setFreeFromTextValue('');
              dispatch(updateFreeFromTextCreateTemplate(request));
              setStateChange({
                letterAction: '',
                saveApiActive: true,
                sendEmail: false,
                customizeValue: '',
                saveActionType: '',
              });
            } else if (extraState?.letterAction === 'SendLetterByEmail') {
                  let msg = `<div>${
                    getCreateLetterDetailData?.header
                  }</div> <div>${
                   getCreateLetterDetailData?.body
                  }</div> <div>${
                    getCreateLetterDetailData?.footer
                  }</div>`;
              const request1 = {
                letterId: data?.letterId,
                contactTypeCd: getCreateLetterDetailData?.contactTypeCd,
                rebateProgramCd: data?.rebateProgramCd,
                mfgId: invoiceDetail?.mfgId,
                templateId: data?.templateId,
                templateVersion: data?.templateVersion,
                userId: logInUser,
                lobStagingVO: {
                  dest: 'EMAIL',
                  invNum: data?.invoiceNum,
                  fileName: `Invoice_${data?.invoiceNum}`,
                  fileContent: null,
                  // toAddress: 'shravan.chaurasiya@conduent.com',
                  // fromAddress: 'omkar.singh@conduent.com',
                  toAddress: toMailId.toMailId,
                  fromAddress: fromMailId.fromMailId,
                  subject: getCreateLetterDetailData?.emailSubject,
                  message: convertHtmlToEmailPlainText(msg),
                  // message: getCreateLetterDetailData?.body,
                  // message: convert(
                  //   getCreateLetterDetailData?.body,
                  //   emailOptions
                  // ),
                },
                corrCommentVO: {
                  corrName: data?.corpName,
                  corpName: data?.corpName,
                  addrLine1: data?.addrLine1,
                  addrLine2: data?.addrLine2,
                  addrLine3: data?.addrLine3,
                  city: data?.city,
                  stateCd: data?.stateCd,
                  zip: data?.zip,
                  zip4: data?.zip4,
                  emailAddr: data?.emailAddr,
                  phoneNum: data?.phoneNum,
                  phoneExtension: data?.phoneExtension,
                  faxNum: data?.faxNum,
                },
              };
              if (
                request1.lobStagingVO.toAddress &&
                request1.lobStagingVO.fromAddress
              ) {
                setStateChange({
                  letterAction: extraState?.letterAction,
                  saveApiActive: false,
                  sendEmail: true,
                });
                dispatch(sendMailWithCreateTemplate(request1));
              } else {
                const val =
                  !request1.lobStagingVO.toAddress &&
                  !request1.lobStagingVO.fromAddress
                    ? 'To & From'
                    : !request1.lobStagingVO.toAddress
                    ? 'To'
                    : !request1.lobStagingVO.fromAddress
                    ? 'FROM'
                    : '';
                setLoading(false);
                msg = EMAIL_ID_NOT_AVAILABLE(val);
                setModalView(true);
                setModalMsg(msg);
              }
            } else if (extraState?.letterAction === 'SendLetter') {
              setStateChange({
                letterAction: '',
                saveApiActive: true,
                sendEmail: false,
                customizeValue: '',
                saveActionType: '',
              });
              dispatch(
                afterMailSendUpdateSendDate({
                  letterId: data.letterId,
                  userId: logInUser,
                })
              );
            } else {
              setViewCustomizeLetter(false);
              callPDFAPIAfterSave(data);
              const request2 = {};
              request2.templateId = data.templateId;
              request2.templateVersion = data?.templateVersion;
              if (RequestData?.selectTypeCd === defaultSelectBy) {
                request2.mfgId = getCreateLetterDetailData.mfgId;
                request2.quarter = RequestData?.quarterValue;
                request2.rebateProgramCd = data?.rebateProgramCd;
              }
              if (RequestData?.selectTypeCd === InvNumSelectBy) {
                request2.invoiceNumber = data?.invoiceNum;
              }
              request2.letterId = data.letterId;
              request2.userId = logInUser;
              dispatch(
                fetchCreateLetterDetail({
                  request: request2,
                  searchData: RequestData,
                  headerDetail: data,
                })
              );
              dispatch(getPrintPreview(request2));
              dispatch(updateCreateLetterSaveApi([]));
              setStateChange({
                letterAction: '',
                saveApiActive: false,
                sendEmail: false,
                customizeValue: '',
                saveActionType: '',
              });
              setErrorStateChange({ detailScreenErrors: [SAVE_NDC] });
            }
          }
        } else {
          setStateChange({
            letterAction: extraState?.letterAction,
            saveApiActive: false,
            sendEmail: false,
            printPdf: false,
          });
          setLoading(false);
          msg = FAIL_PROCESSING_REQUEST;
          setModalView(true);
          setModalMsg(msg);
        }
      }
    }
  }, [saveCreateLetterData, extraState?.saveApiActive]);

  // Redirect invoice detail page after calling invoice api
  React.useEffect(() => {
    setLoading(false);
    if (
      redirect &&
      invoiceDetailsByInvoiceNum &&
      !_.isEmpty(invoiceDetailsByInvoiceNum)
    ) {
      setRedirect(false);
      const updateTabs1 = _.cloneDeep(updateTabs);
      updateTabs1.push({
        navTo: '/display-invoice',
        value: 'Display Invoice',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs1));
      history.push({
        pathname: '/display-invoice',
        invoiceDetailsByInvoiceNum: invoiceDetailsByInvoiceNum.data,
      });
    }
  }, [invoiceDetailsByInvoiceNum]);

  // go to particular invoice action button handler function
  const goToInvoice = async () => {
    setErrorStateChange({ detailScreenErrors: [] });
    if (!_.isEmpty(RequestData) && !_.isEmpty(invoiceDetail)) {
      setRedirect(true);
      setLoading(true);
      await dispatch(
        getInvoiceDetailsByInvNum({ invoiceNum: RequestData?.invoiceNum })
      );
    }
  };

  // go to particular Contract action button handler function
  const goToContract = async () => {
    setErrorStateChange({ detailScreenErrors: [] });
    if (invoiceDetail && !_.isEmpty(invoiceDetail)) {
      dispatch(dispatchCellClick(true));
      dispatch(selectedType('C'));
      searchContractState.contractType = 'onSelect';
      searchContractState.selectedContractType = 'contractId';
      searchContractState.selectedRowData = invoiceDetail?.contractSeqNum;
      searchContractState.selectedContractId = invoiceDetail?.contractSeqNum;
      searchContractState.rebateProgramCode = invoiceDetail?.rebateProgramCd;
      const updateTabs1 = _.cloneDeep(updateTabs);
      updateTabs1.push({
        navTo: '/createContract',
        value: 'Maintain Contract',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs1));
      history.push({
        pathname: '/createContract',
      });
    }
  };

  React.useEffect(()=>{
const loadManufacturer = async ()=>{
  const manufactureType = await dispatch(fetchAllManufacturerDetail({ mfgId: invoiceDetail?.mfgId }));
  setManufactureType(manufactureType?.manufacturerDetailsList?.mfgVO?.mfgTypeCd)
}
if(invoiceDetail && Object.keys(invoiceDetail).length>0){
  loadManufacturer()
}
  },[invoiceDetail])

  // go to particular manufacturer action button handler function
  const goToManufacturer = async () => {
    setErrorStateChange({ detailScreenErrors: [] });
    if (invoiceDetail && !_.isEmpty(invoiceDetail)) {
      dispatch(setSelectManufacturerData({}));
      dispatch(fetchAllManufacturerDetail(null));
      dispatch(getContactDetails(null));
      dispatch(maintainLabelerListData({}));
      dispatch(setMaintainManufacturerTab({}));
      const tempObj = {
        mfgId: invoiceDetail?.mfgId,
        mfgName: invoiceDetail?.mfgName,
        mfgTypeCd: manufactureType,
      };
      tempObj.updateManufacturer = true;
      const result = await dispatch(setSelectManufacturerData(tempObj));
      if (result && Object.keys(result).length > 0) {
        redirectURLLink(
          '/manufacturer-detail',
          'Maintain Manufacturer',
          history,
          dispatch
        );
      }
    }
  };

  // go to particular Rebate Program action button handler function
  React.useEffect(() => {
    if (redirect && pgmView && pgmView.status === '001') {
      setRedirect(false);
      setLoading(false);
      const updateTabs1 = _.cloneDeep(updateTabs);
      const MAINTAIN_ROUTE = '/maintainRebate';
      if (!updateTabs1.some((ob) => ob.navTo === MAINTAIN_ROUTE)) {
        updateTabs1.push({
          navTo: MAINTAIN_ROUTE,
          value: 'Maintain Rebate Program',
        });
        localStorage.setItem('tabItemsData', JSON.stringify(updateTabs1));
      }
      localStorage.setItem('viewpgmdetails', 'true');
      history.push({ pathname: MAINTAIN_ROUTE });
      // dispatch({ type: actiontype.PGM_DETAIL, payload: {} });
    }
  }, [pgmView]);

  const goToRebateProgram = async () => {
    setErrorStateChange({ detailScreenErrors: [] });
    if (invoiceDetail && !_.isEmpty(invoiceDetail)) {
      const request = {
        planType: invoiceDetail?.planTypeCode,
        rebateProg: invoiceDetail?.rebateProgramCd,
      };
      setRedirect(true);
      setLoading(true);
      dispatch(getRebatePgmDetail(request));
    }
  };

  const onSaveLetter = (val) => {
    setErrorStateChange({ detailScreenErrors: [] });
    setLoading(true);
    setIsSaveOpen(false);
    // setStateChange({ letterAction: null });
    const letterHeaderVO = {
      templateId: null,
      templateVersion: null,
      rebateProgramCd: null,
      templateTypeCd: null,
      invoiceNum: null,
      freeFormText: null,
      contactSeqNum: null,
      recipientId: null,
      senderId: null,
      letterId: letterIdToShow,
    };
    if (!_.isEmpty(getCreateLetterDetailData)) {
      letterHeaderVO.templateId = getCreateLetterDetailData.templateId;
      letterHeaderVO.templateVersion =
        getCreateLetterDetailData.templateVersion;
      letterHeaderVO.rebateProgramCd =
        getCreateLetterDetailData.rebateProgramCd;
      letterHeaderVO.recipientId = getCreateLetterDetailData.mfgId;
    }
    if (!_.isEmpty(RequestData)) {
      letterHeaderVO.templateTypeCd =
        RequestData?.selectedTemplate?.templateTypeCd;
      letterHeaderVO.invoiceNum = RequestData.invoiceNum;
      letterHeaderVO.contactSeqNum = getCreateLetterDetailData?.contactSeqNum;
      // if (RequestData?.selectTypeCd === defaultSelectBy) {
      //   letterHeaderVO.invoiceNum = RequestData?.mfgData?.invoiceNum || null;
      // }
    }
    if (!_.isEmpty(getCreateLetterDetailHeader)) {
      letterHeaderVO.freeFormText = getCreateLetterDetailHeader.freeFormText;
    }
    letterHeaderVO.senderId = logInUser;
    const request = {
      actionFlag:
        val === 'SendLetterByEmail'
          ? 'SendLetter'
          : val === 'FreeFromText'
          ? 'Save'
          : val,
      letterHeaderVO: letterHeaderVO,
    };
    setStateChange({
      letterAction: val,
      saveApiActive: true,
      sendEmail: false,
      printPdf:
        val === 'SendLetter' &&
        getCreateLetterDetailData?.mediaCd === printMedia,
    });
    dispatch(saveCreateTemplate(request));
  };

  // after mail send done
  React.useEffect(() => {
    if (extraState?.sendEmail) {
      if (!_.isEmpty(sendMail)) {
        setViewEmail(false);
        if (sendMail.message === 'SUCESS' && sendMail.status === '001') {
          if (sendMail?.createLetterSendLetterVO?.sentDt) {
            setStateChange({
              letterAction: '',
              saveApiActive: true,
              sendEmail: false,
            });
            const newData = _.cloneDeep(saveCreateLetterData);
            const data = newData.createLetterSaveOrUpdateVO.letterHeaderVO;
            if (!_.isEmpty(data)) {
              newData.createLetterSaveOrUpdateVO.letterHeaderVO.sentDt =
                sendMail?.createLetterSendLetterVO?.sentDt;
              dispatch(updateCreateLetterSaveApi(newData));
              dispatch(dispatchSendMailForLetter({}));
              // dispatch(
              //   afterMailSendUpdateSendDate({
              //     letterId: data.letterId,
              //     userId: localStorage.getItem('logInUser'),
              //   })
              // );
            }
          } else {
            setLoading(false);
            setModalView(true);
            setModalMsg(FAIL_PROCESSING_REQUEST);
            setStateChange({
              letterAction: '',
              saveApiActive: false,
              sendEmail: false,
              printPdf: false,
            });
          }
        } else {
          setLoading(false);
          setModalView(true);
          setModalMsg(FAIL_PROCESSING_REQUEST);
          setStateChange({
            letterAction: '',
            saveApiActive: false,
            sendEmail: false,
            printPdf: false,
          });
        }
      }
    }
  }, [sendMail, extraState?.sendEmail]);

  const onSendLetterAction = () => {
    setErrorStateChange({ detailScreenErrors: [] });
    if (getCreateLetterDetailData?.mediaCd === printMedia) {
      onSaveLetter('SendLetter');
    } else if (
      !toMailId?.toMailId ||
      toMailId?.toMailId === '' ||
      !fromMailId?.fromMailId ||
      fromMailId?.fromMailId === ''
    ) {
      setEmailInputValue({
        to: toMailId?.toMailId || '',
        from: fromMailId?.fromMailId || '',
      });
      setViewEmailInput({
        to: !toMailId?.toMailId || toMailId?.toMailId === '',
        from: !fromMailId?.fromMailId || fromMailId?.fromMailId === '',
      });
      setViewEmail(true);
    } else {
      onSaveLetter('SendLetterByEmail');
    }
  };

  // after update email ids
  React.useEffect(() => {
    if (toMailId?.isUpdate || fromMailId?.isUpdate) {
      if (
        toMailId?.toMailId &&
        toMailId?.toMailId !== '' &&
        fromMailId?.fromMailId &&
        fromMailId?.fromMailId !== ''
      ) {
        onSaveLetter('SendLetterByEmail');
        setViewEmail(false);
      } else {
        setModalView(true);
        setModalMsg(FAIL_PROCESSING_REQUEST);
      }
      dispatch(
        dispatchGetToMailID({
          isUpdate: false,
          toMailId: toMailId.toMailId,
        })
      );
      dispatch(
        dispatchGetFromMailID({
          isUpdate: false,
          fromMailId: fromMailId.fromMailId,
        })
      );
    }
  }, [toMailId, fromMailId]);

  // view free from text modal
  const viewFreeFromTextModal = () => {
    setErrorStateChange({ detailScreenErrors: [] });
    // let msg = '';
    // let mView = false;
    let freeFormText = '';
    if (!_.isEmpty(getCreateLetterDetailHeader)) {
      if (getCreateLetterDetailHeader.letterId) {
        freeFormText = getCreateLetterDetailHeader.freeFormText;
        // setFreeFromTextValue(getCreateLetterDetailHeader.freeFormText);
        // setViewCustomizeLetter(true);
        // } else {
        //   msg = SAVE_BEFORE_COMMENT;
        //   mView = true;
      }
      // } else {
      //   msg = SAVE_BEFORE_COMMENT;
      //   mView = true;
    }
    // setModalView(mView);
    // setModalMsg(msg);
    setStateChange({ customizeValue: freeFormText });
    setFreeFromTextValue(freeFormText);
    setViewCustomizeLetter(true);
  };

  // update after enter content in free from text and click ok for save
  const updateFreeFromText = () => {
    if (
      freeFromTextValue &&
      freeFromTextValue !== '' &&
      !_.isNull(freeFromTextValue)
    ) {
      setStateChange({
        customizeValue: freeFromTextValue,
        saveActionType: 'FreeFromText',
      });
      setViewCustomizeLetter(false);
    }
  };

  const mailAction = (flType, val) => {
    setEmailInputValue({
      ...emailInputValue,
      [flType]: val,
    });
  };

  // update email after click ok in email modal and save
  const onOkUpdateToMailId = () => {
    if (viewEmailInput.to && !toEmailIdValid) {
      if (emailInputValue.to && emailInputValue.to !== '') {
        const request = {};
        if (
          getCreateLetterDetailData &&
          !_.isEmpty(getCreateLetterDetailData)
        ) {
          request.contactSeqNum = getCreateLetterDetailData.contactSeqNum;
          request.mailId = emailInputValue.to;
          request.userId = logInUser;
          dispatch(updateToMailIDCreateTemplate(request));
        }
      }
    }
    if (viewEmailInput.from && !fromEmailIdValid) {
      if (emailInputValue.from && emailInputValue.from !== '') {
        dispatch(
          updateFromMailIDCreateTemplate({
            mailId: emailInputValue.from,
            userId: logInUser,
          })
        );
      }
    }
  };

  // full screen action
  const handleFullScreenView = (view) => {
    setErrorStateChange({ detailScreenErrors: [] });
    const dataSet = {
      ...extraState.fullScreenView,
      templateDetail: view,
    };
    setStateChange({ fullScreenView: dataSet });
  };

  const onClickPrint = (flType) => {
    setErrorStateChange({ detailScreenErrors: [] });
    let urls = '';
    if (flType === printMedia && pdfUrl && pdfUrl !== '') {
      urls = pdfUrl;
    }
    if (flType === printDraft && draftPdfUrl && draftPdfUrl !== '') {
      urls = draftPdfUrl;
    }
    if (urls && urls !== '') {
      safeWindowOpen(urls);
    }
  };

  React.useEffect(() => {
    const checkAndSetAttributes = () => {
      const hiddenTextarea = document.querySelector(
        'textarea[aria-hidden="true"]'
      );
      if (hiddenTextarea) {
        hiddenTextarea.setAttribute('id', 'hiddenTextArea');
        // Optionally, you can add an aria-labelledby to link it with a label
        // hiddenTextarea.setAttribute('aria-labelledby', 'hiddenLabel');
        return true;
      }
      return false;
    };
    // Try to set the attributes every 100ms, for up to 1 second
    const intervalId = setInterval(() => {
      if (checkAndSetAttributes()) {
        clearInterval(intervalId); // Stop checking once the element is found
      }
    }, 100);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className=' tabs-container' data-testid='CreateLetterDetail'>
      <Spinner load={loading} />
      <CustomSeparator parent1='Tasks' parent2='Display Letter Details' />
      <DisplaySuccessMessages successMessages={detailScreenErrors || []} />
      <SaveCancelPopup
        data-testid='letter-template-save-popup'
        open={isSaveOpen}
        title='Save'
        onConfim={() => onSaveLetter(saveActionType)}
        onCancel={() => setIsSaveOpen(false)}
      />
      <div className='tab-container' bodyground='white'>
        {!fullScreenView && (
          <div className='mui-custom-form no-margin custom-check'>
            <div className='mt-2'>
              <fieldset
                data-testid='radio-box-component'
                className='custom-fieldset'
              >
                <div className='row'>
                  <div className='col-12 col-sm-6 col-md-3 mb-2'>
                    <SelectBoxWithoutBoxComponent
                      data-testid='letter-id-select-box'
                      className='mt-2'
                      labelName='Letter ID'
                      disabled
                      select={false}
                      defaultValue={letterIdToShow}
                    />
                  </div>
                  <div className='col-12 col-sm-6 col-md-3 mb-2'>
                    <SelectBoxWithoutBoxComponent
                      data-testid='name-input-box'
                      className='mt-2'
                      labelName='Name'
                      required={false}
                      disabled
                      select={false}
                      defaultValue={
                        RequestData?.selectedTemplate
                          ? RequestData?.selectedTemplate?.name
                          : ''
                      }
                    />
                  </div>
                  <div className='col-12 col-sm-6 col-md-3 mb-2'>
                    <SelectBoxWithoutBoxComponent
                      data-testid='mfg-id-input-box'
                      className='mt-2'
                      labelName='Mfg ID'
                      required={false}
                      disabled
                      select={false}
                      defaultValue={
                        getCreateLetterDetailData
                          ? getCreateLetterDetailData?.mfgId
                          : ''
                      }
                    />
                  </div>
                  <div className='col-12 col-sm-6 col-md-3 mb-2'>
                    <SelectBoxWithoutBoxComponent
                      data-testid='Sent-input-box'
                      labelName='Sent'
                      required={false}
                      disabled
                      select={false}
                      defaultValue={sentDtToShow || ''}
                      className={
                        sentDtToShow
                          ? 'mt-2'
                          : 'mt-2 frr-letter-used-indicator'
                      }
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        )}
        {!fullScreenView && (
          <div className='row mt-4 mb-3'>
            <div className='col-12'>
              <div className='btn-wrapper float-right'>
                <Button
                  className='btn btn-success btn-save'
                  data-testid='open_Save'
                  onClick={() => {
                    setIsSaveOpen(true);
                    if (saveActionType !== 'FreeFromText') {
                      setStateChange({
                        saveActionType: 'Save',
                      });
                    }
                  }}
                  disabled={saveActionType === '' || !isEnablebyRole || sentDtToShow}
                  // disabled={
                  //   saveActionType !== 'FreeFromText'
                  //     ? getCreateLetterDetailHeader?.letterId &&
                  //       getCreateLetterDetailHeader?.letterId !== ''
                  //     : false
                  // }
                >
                  <SVGComponent iconName='Icon-awesome-save' />
                  Save
                </Button>
              </div>
            </div>
          </div>
        )}

        <div className='custom-check'>
          <div className='float-left'>
            <CLTabs
              data-testid='letter-template-tabs-comp'
              tabValue={tabs}
              handleChangeTabValue={(newValue) => {
                setStateChange({ tabs: newValue });
              }}
            />
          </div>

          <div className='float-right mt-2'>
            <div className='panel-header'>
              <div className='float-right th-icon-group mt-3'>
                <div className='panel-header'>
                  <OverlayTrigger
                    placement='bottom'
                    overlay={<Tooltip id='action-tooltip'>Action</Tooltip>}
                  >
                    <div className='th-icon ic-actions'>
                      <Dropdown className='icon-dropdown-container'>
                        <Dropdown.Toggle
                          className='icon-dropdown'
                          aria-label='Write Off'
                        >
                          {/* <SVGComponent iconName="Icon-export1" /> */}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            role='button'
                            data-testid='create-letter-print-tab'
                            onClick={() => {
                              onClickPrint(
                                getCreateLetterDetailHeader?.sentDt
                                  ? printMedia
                                  : printDraft
                              );
                            }}
                            disabled={!isEnablebyRole}
                          >
                            {getCreateLetterDetailHeader?.sentDt
                              ? 'Print'
                              : 'Print Draft'}
                          </Dropdown.Item>
                          {!sentDtToShow && (
                            <Dropdown.Item
                              role='button'
                              data-testid='create-letter-send-letter-tab'
                              onClick={onSendLetterAction}
                              disabled={!isEnablebyRole}
                            >
                              Send Letter
                            </Dropdown.Item>
                          )}
                          {getCreateLetterDetailData?.mergeFieldFlag &&
                            !getCreateLetterDetailHeader?.sentDt && (
                              <Dropdown.Item
                                role='button'
                                data-testid='create-letter-customize-letter-tab'
                                onClick={viewFreeFromTextModal}
                              >
                                Customize Letter
                              </Dropdown.Item>
                            )}

                          {tabs !== 'Preview' && (
                            <Dropdown.Item
                              role='button'
                              data-testid='create-letter-preview-tab'
                              onClick={() => {
                                setErrorStateChange({ detailScreenErrors: [] });
                                setStateChange({ tabs: 'Preview' });
                              }}
                            >
                              Preview
                            </Dropdown.Item>
                          )}
                          {tabs !== 'HeaderFooter' && (
                            <Dropdown.Item
                              role='button'
                              data-testid='create-letter-header-footer-tab'
                              onClick={(e) => {
                                setErrorStateChange({ detailScreenErrors: [] });
                                setStateChange({ tabs: 'HeaderFooter' });
                              }}
                              value='header/footer'
                            >
                              Show Header/Footer
                            </Dropdown.Item>
                          )}
                          {tabs !== 'Body' && (
                            <Dropdown.Item
                              role='button'
                              data-testid='create-letter-body-tab'
                              onClick={() => {
                                setErrorStateChange({ detailScreenErrors: [] });
                                setStateChange({ tabs: 'Body' });
                              }}
                            >
                              Show Main
                            </Dropdown.Item>
                          )}

                          <Dropdown.Item
                            role='button'
                            data-testid='create-letter-goto-invoice-tab'
                            onClick={goToInvoice}
                          >
                            Go To Invoice
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            data-testid='create-letter-goto-contact-tab'
                            onClick={goToContract}
                          >
                            Go To Contract
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            data-testid='create-letter-goto-manufacturer-tab'
                            onClick={goToManufacturer}
                          >
                            Go To Manufacturer
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            data-testid='create-letter-goto-rebate-program-tab'
                            onClick={goToRebateProgram}
                          >
                            Go To Rebate Program
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </OverlayTrigger>

                  <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip id='fullScreen-tooltip'>
                        {fullScreenView ? 'Minimize Screen' : 'Full Screen'}
                      </Tooltip>
                    }
                  >
                    <div
                      className={
                        fullScreenView
                          ? 'th-icon ic-fulScreen-exit'
                          : 'th-icon ic-fulScreen'
                      }
                      role='button'
                      tabIndex='0'
                      data-testid='setFullScreenView'
                      onClick={() => handleFullScreenView(!fullScreenView)}
                    >
                      <span className='ic-title'>
                        {fullScreenView ? 'Minimize Screen' : 'Full Screen'}
                      </span>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </div>
          <div className='clearfix devider-line' />

          <div className='tabs-body'>
            {tabs === 'Body' && (
              <div className='frr-displayDisabledContent disabled'>
                <SafeHtmlContent html={getCreateLetterDetailData?.body} />
              </div>
            )}
            {tabs === 'HeaderFooter' && (
              <div>
                <div className='mt-2 frr-displayDisabledContent disabled'>
                  <SafeHtmlContent html={getCreateLetterDetailData?.header} />
                </div>
                <div className='mt-2 frr-displayDisabledContent disabled'>
                  <SafeHtmlContent html={getCreateLetterDetailData?.footer} />
                </div>
              </div>
            )}
            {tabs === 'Preview' && <Preview pdfUrlLink={pdfUrl} />}
          </div>
        </div>
      </div>

      {modalView && modalMsg && (
        <CommonModal
          data-testid='template-detail-errorModal-comp'
          className='dialog-420'
          open={modalView}
          viewHeader
          viewAction
          onOk={() => {
            setModalMsg(null);
            setModalView(false);
          }}
          okTitle='Ok'
          closeTitle={false}
          modalTitle='Warning'
          childrenComponent={<div className='p-3'>{modalMsg}</div>}
        />
      )}

      <div>
        <CommonModal
          data-testid='template-detail-errorModal-comp1'
          open={viewEmail}
          viewAction
          viewHeader
          className='dialog-420'
          okTitle='Ok'
          onOk={onOkUpdateToMailId}
          onClose={() => {
            setEmailInputValue({ to: '', from: '' });
            setViewEmailInput({ to: false, from: false });
            setToEmailValid(false);
            setFromEmailValid(false);
            setViewEmail(false);
          }}
          closeTitle='Cancel'
          modalTitle='Request Email Address'
          childrenComponent={
            <div className='mb-2'>
              <p className='float-right'>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id='print-tooltip'>Print</Tooltip>}
                >
                  <div className='top-bell-icon th-icon'>
                    {getCreateLetterDetailData?.mediaCd === eitherMedia ? (
                      <div
                        onClick={() =>
                          onClickPrint(
                            getCreateLetterDetailHeader?.sentDt
                              ? printMedia
                              : printDraft
                          )
                        }
                      >
                        <SVGComponent iconName='Icon-printer' />
                      </div>
                    ) : (
                      <div>
                        <SVGComponent iconName='Icon-printer-disabled' />
                      </div>
                    )}
                  </div>
                </OverlayTrigger>
              </p>
              <p>{ENTER_VALID_EMAIL_OR_CANCEL}</p>
              {viewEmailInput.to && (
                <SelectBoxWithoutBoxComponent
                  data-testid='email-id-select-box'
                  className='mt-2'
                  labelName={invoiceDetail.contactName}
                  placeholder='Email ID'
                  required
                  select={false}
                  inputProps={{ maxLength: 50 }}
                  defaultValue={emailInputValue.to}
                  filterAction={(e) => mailAction('to', e)}
                  onBlurAction={(e) => setToEmailValid(!emailValidation(e))}
                  isError={
                    toEmailIdValid
                      ? emailInputValue.to && emailInputValue.to !== ''
                        ? EMAIL_INVALID
                        : EMAIL_REQUIRED
                      : null
                  }
                />
              )}
              {viewEmailInput.from && (
                <SelectBoxWithoutBoxComponent
                  data-testid='email-id-select-box1'
                  className='mt-2'
                  labelName={logInUser}
                  placeholder='Email ID'
                  required
                  select={false}
                  inputProps={{ maxLength: 50 }}
                  defaultValue={emailInputValue.from}
                  filterAction={(e) => mailAction('from', e)}
                  onBlurAction={(e) => setFromEmailValid(!emailValidation(e))}
                  isError={
                    fromEmailIdValid
                      ? emailInputValue.from && emailInputValue.from !== ''
                        ? EMAIL_INVALID
                        : EMAIL_REQUIRED
                      : null
                  }
                />
              )}
            </div>
          }
        />
      </div>
      <div className='frr-rem-dialog-container-pt'>
        <CommonModal
          data-testid='template-detail-errorModal-comp2'
          open={CustomizeLetter}
          viewAction
          viewHeader
          okTitle='Ok'
          onOk={updateFreeFromText}
          className='dialog-420'
          onClose={() => {
            setStateChange({
              customizeValue: '',
              saveActionType: saveActionType,
            });
            setViewCustomizeLetter(false);
          }}
          closeTitle='Cancel'
          modalTitle='Customize Letter'
          childrenComponent={
            <>
              <label className='hide-elm' htmlFor='hiddenTextArea'>
                Comments
              </label>
              <legend className='same-font-family mx-0 frr-legend-font d-flex'>
                <span>Comments </span>
              </legend>
              <TextField
                id='outlined-multiline-static'
                label='Comments'
                multiline
                rows={4}
                className='custom-textarea frr-display-hidden-label'
                onChange={(e) => setFreeFromTextValue(e.target.value)}
                defaultValue={freeFromTextValue}
                InputLabelProps={{
                  shrink: false,
                }}
              />
            </>
          }
        />
      </div>
    </div>
  );
}

export default CreateLetterDetail;
